export const convertToCarrierItemCodeMappingObject = (data) => {
  const carrierItemCodeMappingObject = [];

  data.forEach(record => {
    carrierItemCodeMappingObject.push({
      countryCode: record["Country Code"] || record.countryCode,
      carrierCode: record["Carrier Code"] || record.carrierCode,
      itemCode: record["Item Code"] || record.itemCode,
      sku: record["SKU"] || record.sku,
      description: record["Description"] || record.description,
      itemDetails: {
        modelNumber: record["Model Number"] || record.modelNumber || "",
        color: record["Color"] || record.color || "",
      }
    });
  });

  return carrierItemCodeMappingObject;
};
